export const FEMALE = 'FEMALE'
export const MALE = 'MALE'
export const NO_ANSWER = 'NO_ANSWER'
export const OTHER = 'OTHER'
